import React from 'react';
import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { ByLinePlaceholder } from './ByLinePlaceholder';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EICByLinePlaceholder = styled.div({
	height: `${token('space.400', '32px')}`,
});

export const LivePagesByLinePlaceholder = ({ isLivePage }) => {
	if (isLivePage) {
		return <ByLinePlaceholder />;
	} else {
		return (
			<EICByLinePlaceholder data-testid="live-pages-by-line-placeholder">
				&nbsp;
			</EICByLinePlaceholder>
		);
	}
};
